import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { CheckboxFieldWUT } from '../../../ui/checkbox-field';
export const CheckboxWUT = props => {
  const fieldType = FIELD_TYPES.CHECKBOX;
  return /*#__PURE__*/React.createElement(CheckboxFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=checkbox-wut.js.map